import React, { useState } from "react";
import HeaderPanel from "../../components/layout/HeaderPanel";
import {
  descriptionLanguage,
  escapeWithBreakLineAndTranslate,
  formatMessage,
  formatMessageWithParams,
} from "../../utils/helpers/LanguageHelper";
import { ButtonVariants } from "../../styles/fluent/ButtonVariants";
import { Link, Dropdown } from "@fluentui/react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import FooterPanel from "../../components/layout/FooterPanel";
import releaseNotes from "../../../../../assets/json/releaseNote.json";

export const TagetikInfo = () => {
  const [state, setState] = useState({
    releaseNoteVisible: false,
    selectedVersion: releaseNotes[0]?.version || "",
  });

  const selectedReleaseNote = releaseNotes.find((rn) => rn.version === state.selectedVersion);

  return (
    <>
      {!state.releaseNoteVisible ? (
        <>
          <HeaderPanel applyPadding>Info</HeaderPanel>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
              position: "absolute",
              transform: "translate(50%, -50%)",
              top: "55%",
              right: "50%",
            }}
          >
            <span className="brandNameText" style={{ textAlign: "center" }}>
              {formatMessage("cof.base.tagetik")}
              <br />
              {formatMessage("cof.base.intelligentdisclosure")}
            </span>
            <img src="assets/WK Logo.svg" alt="Wolters Kluwer Logo" style={{ margin: "0 25%" }} />
            <span className="versionNumberText" style={{ textAlign: "center" }}>
              {formatMessageWithParams("cof.info.versionnumber", { versionNumber: state.selectedVersion })}
            </span>
            <Link
              style={{ textDecoration: "none" }}
              onClick={() => setState({ ...state, releaseNoteVisible: true })}
              className={ButtonVariants.link}
            >
              {formatMessage("cof.info.releasenote")}
            </Link>
          </div>
        </>
      ) : (
        <>
          <HeaderPanel applyPadding>Release Note</HeaderPanel>
          <Dropdown
            label="Version"
            options={releaseNotes.map((rn) => ({
              key: rn.version,
              text:
                rn.version +
                " - " +
                new Date(rn.date).toLocaleDateString(descriptionLanguage() ?? "default", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }),
            }))}
            selectedKey={state.selectedVersion}
            onChange={(_event, option) => setState({ ...state, selectedVersion: option.key.toString() })}
            styles={{
              dropdown: { width: 200, marginLeft: "0.5rem", borderRadius: "10px" },
              label: { margin: "0.5rem 0rem 0rem 0.5rem" },
            }}
          />
          {selectedReleaseNote?.new?.length ? (
            <div className="card" style={{ margin: "1rem 0.5rem", backgroundColor: "white" }}>
              <div
                className="card"
                style={{
                  backgroundColor: "var(--color-purple)",
                  borderRadius: "2%",
                  width: "fit-content",
                  color: "white",
                  padding: "2px 20px",
                }}
              >
                NEW
              </div>
              <span style={{ marginLeft: "0.5rem" }}>{escapeWithBreakLineAndTranslate(selectedReleaseNote.new)}</span>
            </div>
          ) : null}
          {selectedReleaseNote?.fixed?.length ? (
            <div className="card" style={{ margin: "1rem 0.5rem", backgroundColor: "white" }}>
              <div
                className="card"
                style={{
                  backgroundColor: "var(--color-green)",
                  borderRadius: "10px",
                  width: "fit-content",
                  color: "white",
                  padding: "2px 20px",
                }}
              >
                FIXED
              </div>
              <span style={{ marginLeft: "0.5rem" }}>{escapeWithBreakLineAndTranslate(selectedReleaseNote.fixed)}</span>
            </div>
          ) : null}
          <FooterPanel>
            <PrimaryButton
              className={ButtonVariants.white}
              text={formatMessage("cof.base.back")}
              style={{ float: "left" }}
              onClick={() => setState({ ...state, releaseNoteVisible: false })}
            />
          </FooterPanel>
        </>
      )}
    </>
  );
};
